export default __webpack_public_path__ + "static/ama-logo-e4b2e28e769eb7ad0d6327384885371f.svg";